import styled from "styled-components";

export const FormContainer = styled.div`
  margin-top: 24px;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #1f2937;
  background: #0d1220;
`;

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-bottom: 16px;
`;

export const Label = styled.label`
  font-size: 13px;
  color: #9ca3af;
  opacity: 0.7;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #0d1220;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  padding: 10px;
  border-radius: 10px;
  background: #0d1220;
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  min-height: 80px;
  resize: vertical;
  
  &:focus {
    outline: none;
    border-color: #5ce9ff;
  }
`;

export const FileInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const FileInputLabel = styled.label`
  padding: 10px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid #1f2937;
  color: #e5e7eb;
  font-size: 14px;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const FileInput = styled.input`
  display: none;
`;

export const FileList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #9ca3af;
  margin-top: 4px;
`;

export const SubmitButton = styled.button`
  padding: 12px 24px;
  border-radius: 10px;
  background: ${props => props.disabled ? '#1f2937' : 'linear-gradient(90deg, #00f7d2, #5ce9ff)'};
  color: ${props => props.disabled ? '#777' : '#000'};
  font-weight: 700;
  font-size: 14px;
  border: none;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: opacity 0.2s;
  
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const DescriptionSidebar = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 420px;
  height: 100vh;
  background: #0d1220;
  border-left: 1px solid #1f2937;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(110%)")};
  transition: 0.35s ease;
  padding: 24px;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

`;

export const CertificationSidebar = styled(DescriptionSidebar)``;

export const SidebarOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.75);
  z-index: 10000;
  opacity: ${({ show }) => (show ? 1 : 0)};
  visibility: ${({ show }) => (show ? 'visible' : 'hidden')};
  transition: opacity 0.35s ease, visibility 0.35s ease;
`;

export const SidebarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 50px;
`;

export const SidebarTitle = styled.h3`
  margin: 0;
  color: #e5e7eb;
  font-size: 20px;
`;

export const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #9ca3af;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.1);
    color: #e5e7eb;
  }
`;
